var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Send_2",
    d: "M13.2904 0.716113C12.9569 0.373857 12.4634 0.24635 12.0032 0.380568L1.27216 3.50114C0.786628 3.63603 0.442487 4.02325 0.349783 4.51516C0.255077 5.01579 0.58588 5.65132 1.01806 5.91707L4.37343 7.97933C4.71757 8.19073 5.16175 8.13771 5.44654 7.85048L9.28878 3.98433C9.48219 3.783 9.80232 3.783 9.99573 3.98433C10.1891 4.17894 10.1891 4.49436 9.99573 4.69568L6.14682 8.56251C5.86137 8.84906 5.80802 9.29534 6.0181 9.64162L8.06828 13.0306C8.30837 13.4333 8.72188 13.6615 9.1754 13.6615C9.22875 13.6615 9.28878 13.6615 9.34213 13.6547C9.86234 13.5876 10.2758 13.232 10.4292 12.7286L13.6105 2.01132C13.7506 1.55498 13.6239 1.05837 13.2904 0.716113Z",
    fill: "url(#paint0_linear_22207_4907)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22207_4907",
    x1: 0.333496,
    y1: 5.66146,
    x2: 13.0002,
    y2: 3.99479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8589FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6850F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.527d6e7d7ec0018da56ce2b79f3816c9.svg";
export { ForwardRef as ReactComponent };